import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import useUpdateShopPreferences from "@babackapp/private-api-client/client/use-update-shop-preferences";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { useCarriersContext } from "../use-carriers-context";
import useTranslation from "@babackapp/translations/use-translation";
import UpdatableBoolean from "@/components-legacy/inputs/updatableBoolean";
import RoutingRule from "./components/routing-rules";

const CarriersInformations = () => {
  const t = useTranslation();
  const { shop } = useCarriersContext();
  const isAtLeastAdmin = useViewerHasAtLeastAdminRights();
  const mutation = useUpdateShopPreferences(shop.id);

  const updateShopPreferenceCanReturnWithoutLabel = (canReturn: boolean) =>
    mutation.mutateAsync({
      canReturnWithoutLabel: canReturn,
    });
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("settings.shipping.title")}</CardTitle>
        <CardDescription>{t("settings.shipping.subtitle")}</CardDescription>
      </CardHeader>

      <CardContent className="space-y-6">
        <RoutingRule shop={shop} />
        <UpdatableBoolean
          title={t("settings.shipping.canReturnWithoutLabel")}
          value={shop.preferences.canReturnWithoutLabel}
          readOnly={!isAtLeastAdmin}
          onSave={updateShopPreferenceCanReturnWithoutLabel}
        />
      </CardContent>
    </Card>
  );
};

export default CarriersInformations;
